/** 게시판 목록 기본 페이지 번호 */
export const DEFAULT_PAGE = 1;

/** 게시판 목록 페이지당 항목 수 */
export const DEFAULT_COUNT = 12;

/** 게시판 정렬 컬럼 - 생성일 (초기 기본값) */
export const SORT_COLUMN_DATE = "createDate";

/** 게시판 정렬 컬럼 - 조회수 (sort 값이 있을 때 사용) */
export const SORT_COLUMN_VIEW = "view";
